<mat-form-field>
  <input type="text" [placeholder]="placeholder" matInput [formControl]="entityControl" [matAutocomplete]="auto" [value]="entityControl.value?.name || '' ">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="update()">
    <mat-option *ngFor="let entity of entities | async" [value]="entity">
      {{ entity.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
